import React, {useContext, useMemo, useState, useEffect, useCallback} from 'react'
import _ from 'lodash'
import {getFilterFieldValues} from '../../state/entities/get-filter-field-values/actions'
import useFilterFieldValuesReducer, {
  ActionTypes,
} from '../../state/entities/get-filter-field-values/reducer'

const ReservationGanttContext = React.createContext(null)

function ReservationGanttContextProvider(props) {
  // [A]
  const [viewData, setViewData] = useState({selectedView: null, selectedFilteredView: null})
  const [startDateSec, setStartDateSec] = useState(new Date().setHours(0, 0, 0, 0))
  const [filters, setFilters] = useState([])
  const [viewBreakPoint, setViewBreakPoint] = useState({})
  const [columnHeaders, setColumnHeaders] = useState({primary: [], secondary: []})
  const [groupBy, setGroupBy] = useState(null)
  const [groupByItems, dispatch] = useFilterFieldValuesReducer()
  const [query, setQuery] = useState('')

  useEffect(() => {
    let _cache = localStorage.getItem('_calendar_gantt')
    if (_cache) {
      try {
        _cache = JSON.parse(_cache)
        if (_cache.start_date) {
          setStartDateSec(_cache.start_date)
        }
      } catch (err) {
        console.log("_calendar_gantt can't be loaded", err)
      }
    }
  }, [])

  useEffect(() => {
    // reset if group by changed
    dispatch({type: ActionTypes.RESET})
    if (groupBy) {
      getFilterFieldValues(dispatch, groupBy.field_id, null, {limit: 10, page: 1})
    }
  }, [groupBy, dispatch])

  const _loadMoreGroupItems = useCallback(
    v => {
      if (!groupByItems.isLoading && groupByItems.data.length < groupByItems.total) {
        getFilterFieldValues(dispatch, groupBy.field_id, null, {
          page: groupByItems.page + 1,
          limit: groupByItems.limit,
        })
      }
    },
    [groupByItems, groupBy, dispatch]
  )

  const _setStartDateSec = useCallback(
    v => {
      setStartDateSec(v)
      localStorage.setItem('_calendar_gantt', JSON.stringify({start_date: v}))
    },
    [setStartDateSec]
  )

  const value = {
    filters,
    setFilters,
    viewData,
    setViewData,
    startDateSec,
    setStartDateSec: _setStartDateSec,
    viewBreakPoint,
    setViewBreakPoint,
    columnHeaders,
    setColumnHeaders,
    groupBy,
    setGroupBy,
    groupByItems: groupByItems,
    groupByItemsDispatch: dispatch,
    query,
    setQuery,
    loadMoreGroupItems: _loadMoreGroupItems,
  }

  // [B]
  return (
    <ReservationGanttContext.Provider value={value}>
      {props.children}
    </ReservationGanttContext.Provider>
  )
}

const ReservationGanttContextConsumer = ReservationGanttContext.Consumer

const useReservationGanttContext = () => {
  return useContext(ReservationGanttContext)
}
export default useReservationGanttContext
export {ReservationGanttContext, ReservationGanttContextProvider, ReservationGanttContextConsumer}
